import React, { useEffect, useState, useMemo } from "react";
import Banner from "src/assets/images/website-images/life-health-package-banner.png";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";
import TabProduct from "src/Components/WebsiteComponents/TabProduct";
import { useNavigate } from "react-router-dom";
import {
  convertToKebabCase,
  parseQueryParams,
} from "src/helpers/helperFunctions";
import { QueryPath } from "src/lib/constans";

const AllSpecializationsPage = () => {
  const [loader, setLoader] = useState<boolean>(false);
  const [data, setData] = useState<any[]>([]);
  const navigate = useNavigate();

  const fetchPackages = async () => {
    if (data.length === 0) {
      setLoader(true);
    }
    const { res, err } = await httpRequest<any[]>({
      path: "/provider/special/get",
    });
    if (res) {
      setData(
        res.map((item) => ({
          id: item._id,
          name: item.name,
          image: item.SpecailImage,
        })) || []
      );
    } else {
      toast(err, { type: "error" });
    }
    setLoader(false);
  };

  useEffect(() => {
    fetchPackages();
  }, []);

  /* -------------------------------------------------------------
   *  RENDERED CARDS – flat list (no A-Z grouping)
   * ------------------------------------------------------------- */
  const renderedCards = useMemo(() => {
    if (loader) {
      return Array.from({ length: 12 }).map((_, i) => (
        <TabProduct key={`skeleton-${i}`} skeleton />
      ));
    }

    return data.map((item, idx) => (
      <TabProduct
        id={`specialization-${item.id}`}
        key={item.id || idx}
        data={item}
        onClick={() => {
          const q = {
            [QueryPath.specialization]: item.id,
            [QueryPath.specializationName]: item.name,
          };
          navigate(`/consult-a-doctor?${parseQueryParams(q)}`);
        }}
      />
    ));
  }, [loader, data, navigate]);

  return (
    <div className="bg-banner-white-image w-full h-full relative 2xl:p-4 p-2">
      <div className="view-area-width mx-auto box-design bg-white flex flex-col 2xl:gap-6 gap-4 2xl:p-4 p-2">
        <img
          src={Banner}
          alt="Banner"
          className="w-full max-h-[44vh] object-cover box-design rounded-lg"
          loading="lazy"
        />
        <div className="grid grid-cols-1 lg:grid-cols-4 xl:grid-cols-5 gap-4">
          {renderedCards}
        </div>
      </div>
    </div>
  );
};

export default AllSpecializationsPage;